import React from 'react';
import Markdown from 'markdown-to-jsx';
import styles from './ums-popup-intraction.module.css';
import {IDataProps, IProps} from '../../types/umsPopupIntraction.types';
import {UMSInteractionLabels} from './ums-popup-intraction.utils';

export const UMSTableComponent: React.FC<IProps> = ({data, showDetails}) => {
    const {
        DaznId,
        PopupCount,
        DismissCount,
        CrossGrade,
        CrossGradePlan,
        TimeDate,
        Platform,
        ApplicationArea,
        TableHeader,
        AnnualID,
        InstalmentID,
        MonthID
    } = UMSInteractionLabels;
    const renderTableRows = () => {
        if (data) {
            const dataAsIDataProps = data as IDataProps;
            let billingPeriod = '';
            if (
                dataAsIDataProps.popupShownCount === 0 &&
                dataAsIDataProps.isUserTargeted === false
            ) {
                return (
                    <tr>
                        <td colSpan={8}>
                            The User ID provided is Not Targeted
                        </td>
                    </tr>
                );
            }

            if (dataAsIDataProps.crossGradePlan === AnnualID) {
                billingPeriod = 'Annual';
            } else if (dataAsIDataProps.crossGradePlan === InstalmentID) {
                billingPeriod = 'Instalments';
            } else if (dataAsIDataProps.crossGradePlan === MonthID) {
                billingPeriod = 'Month';
            } else if (dataAsIDataProps.crossGradePlan.includes('#rule')) {
                billingPeriod = 'Unlimited Plus Instalments';
            }

            return (
                <tr>
                    <td>{dataAsIDataProps.daznId}</td>
                    <td>{dataAsIDataProps.popupShownCount}</td>
                    <td>{dataAsIDataProps.dismissedCount}</td>
                    <td>{dataAsIDataProps.crossGrade ? 'Yes' : 'No'}</td>
                    <td>{billingPeriod}</td>
                    <td>{dataAsIDataProps.timeDateofCrossGrade}</td>
                    <td>{dataAsIDataProps.platform}</td>
                    <td>{dataAsIDataProps.applicationArea}</td>
                </tr>
            );
        }

        return (
            <tr>
                <td colSpan={8}>No data available</td>
            </tr>
        );
    };

    return showDetails ? (
        <div className={styles.umsTable}>
            <h3 className={styles.tableHeader} data-test-id="accessText1">
                <Markdown>{TableHeader}</Markdown>
            </h3>
            <div className={styles.tableContainer}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>{DaznId}</th>
                            <th>{PopupCount}</th>
                            <th>{DismissCount}</th>
                            <th>{CrossGrade}</th>
                            <th>{CrossGradePlan}</th>
                            <th>{TimeDate}</th>
                            <th>{Platform}</th>
                            <th>{ApplicationArea}</th>
                        </tr>
                    </thead>
                    <tbody>{renderTableRows()}</tbody>
                </table>
            </div>
        </div>
    ) : (
        <></>
    );
};
